import React from 'react';
import { useSelector } from 'react-redux';
import Choose from '../../assest/ChooseImg.png';
import ProvenImg from '../../assest/Proven.png';
import QualityImg from '../../assest/Quality.png';
import WithInImg from '../../assest/WithIn.png';

const translations = {
  gb: {
    whyChooseUs: "Why Choose Us",
    cards: [
      {
        title: "Proven Expertise",
        text: "Delivering trusted contracting solutions with quality, experience, and integrity."
      },
      {
        title: "Quality Assurance",
        text: "Committed to quality, safety, precision, and consistent project excellence."
      },
      {
        title: "Within Time Work",
        text: "Delivering every project on schedule, without compromising quality."
      }
    ]
  },
  sa: {
    whyChooseUs: "لماذا تختارنا",
    cards: [
      {
        title: "خبرة مثبتة",
        text: "تقديم حلول تعاقدية موثوقة مع الجودة والخبرة والنزاهة."
      },
      {
        title: "ضمان الجودة",
        text: "ملتزمون بالجودة والسلامة والدقة والتميز المستمر في المشاريع."
      },
      {
        title: "العمل في الوقت المحدد",
        text: "تسليم كل مشروع في الموعد المحدد دون المساس بالجودة."
      }
    ]
  },
  fr: {
    whyChooseUs: "Pourquoi nous choisir",
    cards: [
      {
        title: "Expertise éprouvée",
        text: "Fourniture de solutions contractuelles fiables avec qualité, expérience et intégrité."
      },
      {
        title: "Assurance qualité",
        text: "Engagés envers la qualité, la sécurité, la précision et l'excellence constante des projets."
      },
      {
        title: "Respect des délais",
        text: "Livraison de chaque projet dans les délais, sans compromettre la qualité."
      }
    ]
  },
  de: {
    whyChooseUs: "Warum uns wählen",
    cards: [
      {
        title: "Bewährte Expertise",
        text: "Lieferung vertrauenswürdiger Vertragslösungen mit Qualität, Erfahrung und Integrität."
      },
      {
        title: "Qualitätssicherung",
        text: "Verpflichtet zu Qualität, Sicherheit, Präzision und konstanter Projektexzellenz."
      },
      {
        title: "Pünktliche Arbeit",
        text: "Jedes Projekt wird termingerecht geliefert, ohne die Qualität zu beeinträchtigen."
      }
    ]
  }
};
const ChooseUs = () => {
  const { language } = useSelector((state) => state.language);
  const t = translations[language] || translations.gb;

  const cards = [
    { icon: ProvenImg, title: t.cards[0].title, text: t.cards[0].text },
    { icon: QualityImg, title: t.cards[1].title, text: t.cards[1].text },
    { icon: WithInImg, title: t.cards[2].title, text: t.cards[2].text },
  ];

  return (
    <div
      className="container-fluid bg-dark text-white"
      style={{ minHeight: '100vh', overflow: 'hidden' }}
      dir={language === 'sa' ? 'rtl' : 'ltr'}
    >
      <div className="container h-100">
        <div className="row h-90 g-0">
          {/* Left Content */}
          <div className="col-lg-7 d-flex flex-column justify-content-center">
            <h2 className="text-white fw-bold mb-4 text-center text-lg-start">
              {t.whyChooseUs}
              <div className="d-flex justify-content-center justify-content-lg-start mt-3">
                <div className="bg-white" style={{ width: '40px', height: '3px' }} />
                <div className="bg-white mx-1" style={{ width: '5px', height: '3px' }} />
                <div className="bg-white" style={{ width: '40px', height: '3px' }} />
              </div>
            </h2>

            <div className="row mt-4">
              {cards.map((card, index) => (
                <div className="col-12 col-md-4 mb-5" key={index}>
                  <div
                    className="position-relative bg-white text-dark text-center rounded p-4 pt-5 h-100 shadow-lg card-hover"
                    style={{
                      transition: 'all 0.4s ease',
                      cursor: 'pointer',
                      border: '1px solid rgba(255,0,0,0.2)',
                    }}
                  >
                    {/* Floating Icon */}
                    <div
                      className="position-absolute top-0 start-50 translate-middle icon-glow"
                      style={{
                        width: '60px',
                        height: '60px',
                        backgroundColor: 'white',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        transition: 'all 0.3s ease',
                      }}
                    >
                      <img src={card.icon} alt={card.title} style={{ height: '30px' }} />
                    </div>

                    <h5 className="fw-bold mt-4">{card.title}</h5>
                    <p className="text-muted mb-0" style={{ fontSize: '0.95rem' }}>
                      {card.text}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right Image */}
          {/* <div className="col-lg-5 d-flex justify-content-end align-items-end">
            <img
              src={Choose}
              alt="Construction site"
              className="w-80 h-70 "
              style={{
                objectFit: 'cover',
                transition: 'all 0.4s ease',
                width:'100%',
              }}
            />
          </div> */}


          <div className="col-lg-5 d-flex justify-content-end align-items-end">
            <img
              src={Choose}
              alt="Construction site"
              className="img-fluid"
              style={{
                objectFit: 'cover',
                transition: 'all 0.4s ease',
                maxWidth: '100%',
                maxHeight: 'auto',

              }}
            />
          </div>


        </div>
      </div>

      {/* Hover Effects CSS */}
      <style>{`
        @media (min-width: 768px) {
          .card-hover:hover {
            transform: translateY(-10px) scale(1.05);
            box-shadow: 0 10px 30px rgba(255, 0, 0, 0.4);
            background-color: #fff;
            color: #000;
          }

          .card-hover:hover .icon-glow {
            box-shadow: 0 0 20px rgba(255, 0, 0, 0.6), 0 0 10px rgba(255, 0, 0, 0.4);
            transform: translate(-50%, -50%) scale(1.1);
          }

          .img-hover-glow:hover {
            transform: scale(1.05);
            filter: brightness(1.1);
            box-shadow: 0 0 25px rgba(255, 0, 0, 0.5);
          }
        }
      `}</style>
    </div>
  );
};

export default ChooseUs;
